// const API_BASE = "https://www.assocham.org/api"; // update if API is in a different folder

// export async function fetchKnowledgePublications({ page = 1, limit = 6, all = false } = {}) {
//   const url = all
//     ? `${API_BASE}/get_knowledge_publications.php?all=1`
//     : `${API_BASE}/get_knowledge_publications.php?page=${page}&limit=${limit}`;

//   const res = await fetch(url);
//   if (!res.ok) throw new Error("Failed to fetch knowledge publications");

//   const data = await res.json();
//   if (!data.success) throw new Error("Knowledge publications API returned an error");

//   return data;
// }




// new code 




// ---------------------------------------------------------------
// API module for Knowledge Publications (assocham.org)
// ---------------------------------------------------------------

const API_BASE = "https://www.assocham.org/api"; // update if API is in a different folder
const SITE_BASE = "https://www.assocham.org"; // base for detail pages (read publication)

export async function fetchKnowledgePublications({ page = 1, limit = 6, all = false } = {}) {
  const url = all
    ? `${API_BASE}/get_knowledge_publications.php?all=1`
    : `${API_BASE}/get_knowledge_publications.php?page=${page}&limit=${limit}`;

  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to fetch knowledge publications");

  const data = await res.json();
  if (!data.success) throw new Error("Knowledge publications API returned an error");

  return data;
}

/**
 * Builds the full "Read Publication" URL for a card/slider item.
 * Works with any of these API field names: detailUrl / detail_url / url
 *
 * - If the API already returns a full URL (https://...) it is used as-is.
 * - If it returns a relative file path like "read-publication.php?id=45"
 *   or "/read-publication.php?id=45", it is prefixed with
 *   https://www.assocham.org  →  https://www.assocham.org/read-publication.php?id=45
 */
export function getPublicationDetailUrl(item) {
  const raw = item?.detailUrl || item?.detail_url || item?.url || "";
  if (!raw) return "#";

  // already an absolute URL → use as-is
  if (/^https?:\/\//i.test(raw)) return raw;

  // relative path → attach asscham.org base
  return `${SITE_BASE}/${String(raw).replace(/^\/+/, "")}`;
}
